import type { TileColor } from '../../game/boardMVC/TileColor';
import type { ResourceMap } from '../../app/resources/types';
import type { TimeLimit } from '../../libs/timeLimit/types';

export enum PredefinedVisualType {
  Leaf = 'Leaf',
  Unicorn = 'Unicorn',
  Bee = 'Bee',
  Flame = 'Flame',
}

export enum VisualConfigType {
  Predefined = 'Predefined',
  Custom = 'Custom',
}

interface PredefinedVisualConfig {
  configType: VisualConfigType.Predefined;
  visualType: PredefinedVisualType;
}

interface CustomVisualConfig {
  configType: VisualConfigType.Custom;
  iconLayoutRaw: string;
  backgroundLayoutRaw: string;
}

interface TokenMedianCalculation {
  median: true;
  medianMultiplier: number;
}

export interface RewardConfig {
  rewards: ResourceMap;
  tokensReq: number;
}

export interface CollectionEventRewardProgress {
  rewardIndex: number;
  rewards: ResourceMap;
  progress: number;
  target: number;
}

export interface RewardConfigToCalculate {
  rewards: ResourceMap;
  tokensReq: null;
  calculation: TokenMedianCalculation;
}

export interface CollectionEventAppState {
  currentEvent: CollectionEventConfig | null;
  tokensCollectedHistory: number[];
}

export interface CollectionEventInfo {
  eventId: string;
  tokens: number;
}

export type CollectionEventVisualConfig = PredefinedVisualConfig | CustomVisualConfig;

export interface CollectionEventConfig {
  id: string;
  title: Record<string, string>;
  tokensCollected: number;
  tokensLastSeen: number;
  tokenType: TileColor[];
  description: {
    text: Record<string, string>;
    colorTags: Record<string, string>;
  };
  timeLimit: TimeLimit;
  visuals: PredefinedVisualConfig | CustomVisualConfig;
  priority: boolean;
  rewards: (RewardConfig | RewardConfigToCalculate)[];
  rewardsLoop: { start: number; end: number };
  tempTokens: number;
}

export interface CollectionEventSystemConfig {
  regularEvents: CollectionEventConfig[];
  priorityEvents: CollectionEventConfig[];
}
